module.exports = __webpack_public_path__ + "static/img/2.16cfa1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hsyj/2.png
// module id = xpRF
// module chunks = 1